// Format i njesuar per dates te shfaqura tek perdoruesi: DITE/MUAJ/VIT - kurre ISO e papërpunuar
// (p.sh. "2026-07-07T06:00:00.000Z") si ne disa vende te platformes me pare (raportuar nga Egzoni).

const DATE_ONLY_RE = /^(\d{4})-(\d{2})-(\d{2})$/;

function pad2(value: number): string {
  return String(value).padStart(2, "0");
}

// Nje "date-only" string (YYYY-MM-DD, pa kohe) lexohet fjale-per-fjale, pa kaluar nga Date/
// timezone - ndryshe nje shikues jashte Europe/Tirane rrezikon nje dite "off-by-one".
export function formatDate(value: string | Date | null | undefined): string {
  if (!value) return "-";
  if (typeof value === "string") {
    const match = DATE_ONLY_RE.exec(value.trim());
    if (match) return `${match[3]}/${match[2]}/${match[1]}`;
  }
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return typeof value === "string" ? value : "-";
  return `${pad2(date.getDate())}/${pad2(date.getMonth() + 1)}/${date.getFullYear()}`;
}

export function formatDateTime(value: string | Date | null | undefined): string {
  if (!value) return "-";
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return typeof value === "string" ? value : "-";
  const datePart = `${pad2(date.getDate())}/${pad2(date.getMonth() + 1)}/${date.getFullYear()}`;
  const timePart = `${pad2(date.getHours())}:${pad2(date.getMinutes())}`;
  return `${datePart} ${timePart}`;
}
